import styled from 'styled-components';
export const TEXT_SIZE_CONSTANT = {
    SMALL: 'small',
    SEMI_MEDIUM: 'semiMedium',
    MEDIUM: 'medium',
    LARGE: 'large'
};
export const textSizeMap = {
    small: '12px',
    semiMedium: '14px',
    medium: '16px',
    large: '18px',
};
export const CommonText = styled.div `
  font-size: ${props => textSizeMap[props.size]};
  color: ${props => props.color ? props.color : "#fefefe"};
  font-family: Inter;
  font-style: normal;
  font-weight: ${props => props.weight};
  line-height: 24px;
`;
//# sourceMappingURL=index.js.map